/* @jsx mdx */
  import React from 'react'
  import { mdx } from '@mdx-js/react'
  /* @jsx mdx */
import { Playground, Props } from 'docz'
import Text from './'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "text"
    }}>{`Text`}</h1>
    <h2 {...{
      "id": "import"
    }}>{`Import`}</h2>
    <p><inlineCode parentName="p">{`import { Text } from '@blasterjs/core'`}</inlineCode></p>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic Usage`}</h2>
    <p>{`Composes `}<a parentName="p" {...{
        "href": "/primitives/"
      }}><inlineCode parentName="a">{`Box`}</inlineCode></a>{` and exposes text based prop functionality: `}<inlineCode parentName="p">{`color`}</inlineCode>{`, `}<inlineCode parentName="p">{`fontFamily`}</inlineCode>{`, `}<inlineCode parentName="p">{`fontSize`}</inlineCode>{`, `}<inlineCode parentName="p">{`fontWeight`}</inlineCode>{`, `}<inlineCode parentName="p">{`textAlign`}</inlineCode>{`, `}<inlineCode parentName="p">{`lineHeight`}</inlineCode>{`, `}<inlineCode parentName="p">{`letterSpacing`}</inlineCode>{`.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`<Text>`}</inlineCode>{` component renders a `}<inlineCode parentName="p">{`<span>`}</inlineCode>{` with basic styles by default.`}</p>
    <Playground __position={0} __code={'<Text>Hello world</Text>\n<br />\n<Text tag=\"p\">This is a paragraph</Text>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Text
    }} mdxType="Playground">
  <Text mdxType="Text">Hello world</Text>
  <br />
  <Text tag="p" mdxType="Text">This is a paragraph</Text>
    </Playground>
    <h2 {...{
      "id": "semantic-text-tag-elements"
    }}>{`Semantic text tag elements`}</h2>
    <Playground __position={1} __code={'<Text tag=\"strong\">Strong</Text>\n<br />\n<Text tag=\"b\">Bold</Text>\n<br />\n<Text tag=\"i\">Italic</Text>\n<br />\n<Text tag=\"u\">Underline</Text>\n<br />\n<Text tag=\"abbr\">I18N</Text>\n<br />\n<Text tag=\"del\">Deleted</Text>\n<br />\n<Text tag=\"em\">Emphasis</Text>\n<br />\n<Text tag=\"s\">Strikethrough</Text>\n<br />\n<Text tag=\"code\">Code</Text>\n<br />\n<Text tag=\"pre\">Pre</Text>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Text
    }} mdxType="Playground">
  <Text tag="strong" mdxType="Text">Strong</Text>
  <br />
  <Text tag="b" mdxType="Text">Bold</Text>
  <br />
  <Text tag="i" mdxType="Text">Italic</Text>
  <br />
  <Text tag="u" mdxType="Text">Underline</Text>
  <br />
  <Text tag="abbr" mdxType="Text">I18N</Text>
  <br />
  <Text tag="del" mdxType="Text">Deleted</Text>
  <br />
  <Text tag="em" mdxType="Text">Emphasis</Text>
  <br />
  <Text tag="s" mdxType="Text">Strikethrough</Text>
  <br />
  <Text tag="code" mdxType="Text">Code</Text>
  <br />
  <Text tag="pre" mdxType="Text">Pre</Text>
    </Playground>
    <h2 {...{
      "id": "prop-styling"
    }}>{`Prop styling`}</h2>
    <Playground __position={2} __code={'<Text fontWeight=\"bold\">I am bold</Text>\n<br />\n<Text color=\"primary\">Primary color</Text>\n<br />\n<Text textAlign=\"center\" fontSize=\"12px\" tag=\"p\">\n  Small and centered\n</Text>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Text
    }} mdxType="Playground">
  <Text fontWeight="bold" mdxType="Text">I am bold</Text>
  <br />
  <Text color="primary" mdxType="Text">Primary color</Text>
  <br />
  <Text textAlign="center" fontSize="12px" tag="p" mdxType="Text">Small and centered</Text>
    </Playground>
    <h2 {...{
      "id": "proptypes"
    }}>{`PropTypes`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Prop`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Box props`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "/primitives/"
            }}>{`Box`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${fontFamily}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${fontSize}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${fontWeight}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${textAlign}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${lineHeight}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${letterSpacing}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${color}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "theming"
    }}>{`Theming`}</h2>
    <h3 {...{
      "id": "schema"
    }}>{`Schema`}</h3>
    <pre><code parentName="pre" {...{}}>{`{
  fonts: {
    fontFamily
  },
  fontSizes: {
    fontSize
  },
  styles: css\`
    ...
  \`
}
`}</code></pre>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/raster-foundry/blasterjs/tree/master/packages/core/theme/components/text"
        }}>{`Default theme`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#"
        }}>{`Learn more about themeing`}</a></li>
    </ul>
    </MDXLayout>;
}

MDXContent.isMDXComponent = true;
  